import { GET_BILL_FUTURE_STATEMENT, GET_BILL_FUTURE_STATEMENT_SUCCESS, GET_BILL_FUTURE_STATEMENT_FAILURE } from '../actions/futureStatement';

const initialState = { cached: false };

export default function futureStatement(state = initialState, action) {
  switch (action.type) {
    case GET_BILL_FUTURE_STATEMENT:
      return {
        ...state,
        loading: true,
        cached: true,
        error: false,
      };
    case GET_BILL_FUTURE_STATEMENT_SUCCESS:
      return {
        ...state,
        futureStatement: action.payload.futureStatements[0],
        loading: false,
      };
    case GET_BILL_FUTURE_STATEMENT_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: true,
      };
    default:
      return state;
  }
}
